import React, { useState, useEffect, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import "./Forms.css";
import ContactTable from "../../Components/FormsComponent/ContactTable";
import NewsLetterTable from "../../Components/FormsComponent/NewsLetterTable";
import CareersTable from "../../Components/FormsComponent/CareersTable";
import BottomToust from "../../Components/BottomToust/BottomToust";

const AllForms = () => {
  const [selectedForm, setSelectedForm] = useState("Careers");
  const [showMessage, setShowMessage] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [error, setError] = useState(null);
  const [inProp, setInProp] = useState(true);
  const nodeRef = useRef(null);

  const handleSwitchForm = (form) => {
    if (form !== selectedForm) {
      setInProp(false);
      setTimeout(() => {
        setSelectedForm(form);
        setInProp(true);
      }, 300);
    }
  };

  const renderTable = () => {
    const commonProps = {
      setShowMessage,
      setToastMessage,
      setError,
    };

    switch (selectedForm) {
      case "Careers":
        return <CareersTable {...commonProps} />;
      case "NewsLetter":
        return <NewsLetterTable {...commonProps} />;
      case "Contact Us":
        return <ContactTable {...commonProps} />;
      default:
        return null;
    }
  };

  const handleCloseMessageModal = () => {
    setShowMessage(false);
  };

  useEffect(() => {
    if (showMessage === true) {
      const timeOut = setTimeout(() => {
        setShowMessage(false);
      }, 3000);

      return () => clearTimeout(timeOut);
    }
  }, [showMessage]);

  return (
    <div className="AllFormsPage">
      <div className="FormsComponent">
        <div className="FormHandling">
          <div className="Header">All Forms</div>
          <div className="NavigationHandling">
            <div className="Sidebar-LeftContent">
              {["Careers", "NewsLetter", "Contact Us"].map((form) => (
                <div
                  key={form}
                  className={`Sidebar-Element ${selectedForm === form ? "active" : ""}`}
                  onClick={() => handleSwitchForm(form)}
                >
                  {form}
                </div>
              ))}
            </div>
            <div className="Sidebar-RightContent">
              <CSSTransition
                in={inProp}
                timeout={300}
                classNames="fade"
                unmountOnExit
                nodeRef={nodeRef}
              >
                <div ref={nodeRef} className="Data-Content">
                  {renderTable()}
                </div>
              </CSSTransition>
            </div>
          </div>
        </div>
      </div>
      <BottomToust
        showMessage={showMessage}
        message={toastMessage}
        handleCloseMessageModal={() => handleCloseMessageModal()}
      />
    </div>
  );
};

export default AllForms;